"use strict";
exports.__esModule = true;
exports.trackAwin = void 0;
var tslib_1 = require("tslib");
var trackAwin = function (_a) {
    var awc = _a.awc, affid = _a.affid, cookie = _a.cookie;
    return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
        var hussleDomain, query;
        return (0, tslib_1.__generator)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    hussleDomain = process.env.NEXT_PUBLIC_HUSSLE_DOMAIN;
                    query = "awc=".concat(awc);
                    if (affid)
                        query = "".concat(query, "&affid=").concat(affid);
                    return [4, fetch("".concat(hussleDomain, "/test?").concat(query), {
                            credentials: 'include',
                            headers: { cookie: cookie }
                        })];
                case 1:
                    _b.sent();
                    return [2];
            }
        });
    });
};
exports.trackAwin = trackAwin;
